<template>
    <div>

        <button @click="connectDevice">连接蓝牙设备</button>
    </div>

</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: 'BlueTooth', // 组件名称
    components: {

    },
    watch: {
    },
    computed: {
        ...mapGetters(['getTranslation']),
    },
    data() {
        return {
            device: null,
            characteristic: null,
            isConnected: false,
            receivedData: [], // 存储接收到的数据
            error: null

        }
    },
    mounted() {

    },
    created() {
        this.init();
    },
    methods: {
        init() {

        },
        async connectDevice() {
            // 1. 检查浏览器支持
            if (!navigator.bluetooth) {
                alert('您的浏览器不支持Web蓝牙API。');
                return;
            }
            try {
                let serviceName = "0000180d-0000-1000-8000-00805f9b34fb";
                // 2. 请求用户选择设备（可以按服务过滤）
                const device = await navigator.bluetooth.requestDevice({
                    acceptAllDevices: true, // 显示所有设备
                    // 或通过服务UUID精确过滤：filters: [{ services: ['battery_service'] }]
                    optionalServices: [serviceName] // 需要访问的服务
                });
                await this.ensureConnected(device);

                console.log('选择的设备信息:', {
                    name: device.name,
                    id: device.id, // 包含MAC地址
                    uuids: device.uuids // 设备广播的服务列表
                });


                console.log('已选择设备：', device.name);
                // 3. 连接GATT服务器
                const server = await device.gatt.connect();
                console.log('已连接GATT服务器');
                // ... 后续操作（获取服务、读写特征值）


                const services = await server.getPrimaryServices();
                console.log('📋 设备实际提供的服务列表：');

                services.forEach(service => {
                    console.log(`  - UUID: ${service.uuid}`);

                    // 可选：将标准UUID转换为可读名称
                    const serviceName = this.getStandardServiceName(service.uuid);
                    if (serviceName) console.log(`    名称: ${serviceName}`);
                });



                let characteristicName = "00002a37-0000-1000-8000-00805f9b34fb";
                const service = await server.getPrimaryService(serviceName);
                // 5. 获取特征值
                this.characteristic = await service.getCharacteristic(characteristicName);


                // 3. 检查是否支持通知
                if (!this.characteristic.properties.notify) {
                    throw new Error('该特征值不支持通知功能。');
                }

                // 4. 启动通知并监听数据
                await this.startListening();

            } catch (error) {
                console.error('连接失败：', error);
            }
        },
        async ensureConnected(device) {
            if (!device.gatt.connected) {
                console.warn('连接已断开，正在重新连接...');
                try {
                    await device.gatt.connect();
                    console.log('重新连接成功');
                } catch (reconnectError) {
                    console.error('重连失败:', reconnectError);
                    throw new Error('无法重新连接到设备');
                }
            }
        },
        async startListening() {
            // 先添加监听器
            this.characteristic.addEventListener('characteristicvaluechanged', this.handleDataReceived);
            // 再启动通知
            await this.characteristic.startNotifications();
            console.log('数据监听已启动');
        },

        handleDataReceived(event) {
            const value = event.target.value;
            console.log('接收到数据:', value.buffer);

           let rs = this.parseDataFromBuffer(value.buffer);
           console.log('解析后的数据:', rs);

            
        },

        async stopNotifications() {
            if (this.characteristic) {
                await this.characteristic.stopNotifications();
                this.characteristic.removeEventListener('characteristicvaluechanged', this.handleDataReceived);
                console.log('已停止接收数据');
            }
        },
        // 辅助函数：将UUID转换为可读的服务名称
        getStandardServiceName(uuid) {
            const shortUuid = uuid.replace('0000', '').replace('-0000-1000-8000-00805f9b34fb', '');
            const serviceMap = {
                '180d': '心率服务',
                '1813': '跑步速度与步频',
                '180f': '电池服务',
                '180a': '设备信息',
                '1816': '骑行速度与踏频',
                // 更多标准服务映射...
            };
            return serviceMap[shortUuid.toLowerCase()];
        },
        parseDataFromBuffer(buffer) {
                const dataView = new DataView(buffer);
                let parsed = {};
                console.log('DataView:',dataView);
                // 示例1：解析一个16位有符号整数（大端序）
                // if (dataView.byteLength >= 2) {
                //     parsed.intValue = dataView.getUint16(0, false); 
                // } else {                    
                //     // 根据实际情况处理，例如读取8位整数或者设置为null
                //     parsed.intValue = dataView.getUint8(0); // 或者用其他方式
                // }
                
                // 示例2：解析一个32位浮点数（小端序）
                // parsed.floatValue = dataView.getFloat32(0, true);
                
                // 示例3：解析一串UTF-8文本
                 const textDecoder = new TextDecoder('utf-8');
                 parsed.text = textDecoder.decode(buffer);
                
                // 实际解析逻辑完全取决于你的设备
                // 例如，一个心率包可能：第0位是标志位，第1位是心率值
               
              

                return parsed;
            }

    },


}
</script>
<style></style>
<style scoped>
@import url('../../assets/style/list.css');
</style>
